import React, { Component } from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import OrderLineListItem from '../components/OrderLineListItem'
import * as resource from '../constants/Resources'
import { getTranslation } from '../actions/dataActions'

class OrderLine extends Component {
    constructor(props) {
        super(props);
        this.handleTouchTap = this.handleTouchTap.bind(this);
        this.state = {
            showLines: false
        };
    }

    handleTouchTap() {
        this.setState(state => ({ showLines: !state.showLines }));
        this.props.Callback(this.props.Order);
    }

    render() {
        return (
            <div>
                {this.props.show &&
                    <div>
                        <button className="orderListItem" onClick={evt => this.handleTouchTap(this.props.Order)}>
                            {!this.state.showLines &&
                                <table className="orderTitle">
                                    <tr>
                                        <th>
                                            #{this.props.Order.OrderNumber }
                                            {this.props.Order.CustomId != null &&
                                                <label>
                                                     &nbsp;- {this.props.Order.CustomId}
                                                </label>
                                            }
                                        </th>
                                        <td>
                                            {this.props.Order.CustomerName}
                                        </td>
                                        <td>
                                            {this.props.Order.OrderDate.toLocaleString()}
                                        </td>
                                        <td>
                                            {this.props.Order.ObjectItemNumber}
                                        </td>
                                    </tr>
                                </table>
                            }
                            {this.state.showLines &&
                                <table className="orderTitleDetails">
                                    <tr>
                                        <td>
                                            <b>{this.props.getTranslation(resource.ORDER_NUMBER)}:</b> #{this.props.Order.OrderNumber}
                                        </td>
                                        <td>
                                            <b>{this.props.getTranslation(resource.ORDER_DATE)}:</b> {this.props.Order.OrderDate.toLocaleString()}
                                        </td>
                                        <td>
                                            <b>{this.props.getTranslation(resource.EMPLOYEE)}:</b> {this.props.Order.SystemUserName}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <b>{this.props.getTranslation(resource.CUSTOMER)}:</b> {this.props.Order.CustomerName}
                                        </td>
                                        <td>
                                            <b>{this.props.getTranslation(resource.PICKUPDATE)}:</b> {this.props.Order.PickupDate.toLocaleString()}
                                        </td>
                                    </tr>
                                </table>
                            }
                            <Ink />
                        </button>
                        <div>
                            <OrderLineListItem
                                key={this.props.Order.OrderNumber}
                                OrderId={this.props.Order.OrderId}
                                OrderLines={this.props.OrderLines}
                                show={this.state.showLines}
                            />
                        </div>
                    </div>
                }
            </div>
        )
    }
}

OrderLine.propTypes = {
    Callback: PropTypes.func
}
function mapStateToProps() {
    return {

    }
}

export default connect(mapStateToProps, {
    getTranslation
})(OrderLine)


// WEBPACK FOOTER //
// src/components/OrderLine.jsx